var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVerify(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.3467 32.0002L28.7733 38.4535L41.6533 25.5469",
    stroke: "url(#paint0_linear_1344_785)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.6667 6.53352C30.5067 4.96018 33.52 4.96018 35.3867 6.53352L39.6 10.1602C40.4 10.8535 41.8933 11.4135 42.96 11.4135H47.4933C50.32 11.4135 52.64 13.7335 52.64 16.5602V21.0935C52.64 22.1335 53.2 23.6535 53.8933 24.4535L57.52 28.6669C59.0933 30.5069 59.0933 33.5202 57.52 35.3869L53.8933 39.6002C53.2 40.4002 52.64 41.8935 52.64 42.9602V47.4935C52.64 50.3202 50.32 52.6402 47.4933 52.6402H42.96C41.92 52.6402 40.4 53.2002 39.6 53.8935L35.3867 57.5202C33.5467 59.0935 30.5333 59.0935 28.6667 57.5202L24.4533 53.8935C23.6533 53.2002 22.16 52.6402 21.0933 52.6402H16.48C13.6533 52.6402 11.3333 50.3202 11.3333 47.4935V42.9335C11.3333 41.8935 10.7733 40.4002 10.1067 39.6002L6.50668 35.3602C4.96001 33.5202 4.96001 30.5335 6.50668 28.6935L10.1067 24.4535C10.7733 23.6535 11.3333 22.1602 11.3333 21.1202V16.5335C11.3333 13.7068 13.6533 11.3868 16.48 11.3868H21.0933C22.1333 11.3868 23.6533 10.8268 24.4533 10.1335L28.6667 6.53352Z",
    stroke: "url(#paint1_linear_1344_785)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1344_785",
    x1: 22.2402,
    y1: 32.0003,
    x2: 41.7599,
    y2: 32.0003,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#009DAC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#8CC63F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F29100"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1344_785",
    x1: 5.05234,
    y1: 32.0271,
    x2: 58.9945,
    y2: 32.0271,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#009DAC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#8CC63F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F29100"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerify);
export default __webpack_public_path__ + "static/media/verify.a492263a171d22ea48076293ca1e15ec.svg";
export { ForwardRef as ReactComponent };